import styled from 'styled-components';

export const AddAvatarModalContainer = styled.form`
  padding-top: 37px;
  padding-bottom: calc(16px + var(--ion-safe-area-bottom));

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #1d201f;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;

    color: #5b5b5b;
  }

  .gap-10px {
    margin-bottom: 10px;
  }

  .gap-24px {
    margin-bottom: 24px;
  }

  .top-24px {
    margin-top: 24px;
  }
`;
